function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export default class Freeform
{

	constructor()
	{
		this._freeform = document.querySelector(".jsFreeform");
		if (this._freeform) this.init();
	}

	init()
	{
		this.lookForFreeformsToInit();
	}

	lookForFreeformsToInit()
	{

		var forms = document.querySelectorAll(".jsFreeform");
		var i = 0;
		forms.forEach(form =>
		{
			if(typeof(form.dataset.id) !== "undefined")
			{
					let formIdElement = document.getElementById(form.dataset.id);
					if (formIdElement)
					{
						formIdElement.setAttribute('aria-label', 'Form Selector');
						formIdElement.setAttribute('href', 'javascript:;');
					}
			}

			form.addEventListener('freeform-ready', function(event)
			{
				const freeform = event.target.freeform;

				// Do something on a successful ajax submit
				freeform.addOnSuccessfulAjaxSubmit(function(event, form, response) {
					setCookie('form-' + form.dataset.handle, '1', 365);
					var pageRestriction = form.closest(".page-restriction");
					if(typeof(pageRestriction) !== "undefined" && pageRestriction != null)
					{
						window.location.reload();
					}
					else if (typeof(formsQueries[form.dataset.id]['returnUrl']) === "undefined" || (typeof(formsQueries[form.dataset.id]['returnUrl']) !== "undefined" && formsQueries[form.dataset.id]['returnUrl'] != ''))
					{
						window.location.href = response.returnUrl;
					}
				});

				// Return the form to the specified Return URL upon success
				// freeform.addOnAfterAjaxSubmit((event, form, response) => {
				//   if (response.returnUrl)
				//   {
				//     window.location.href = response.returnUrl;
				//   }
				// })

				// Override the error and success message element class names
				freeform.setOption('errorClassBanner', 'form__error-banner');
				freeform.setOption('errorClassList', 'form__errors-list');
				freeform.setOption('errorClassField', 'form__field-has-errors');
				freeform.setOption('successClassBanner', 'form__success-banner');

				// Override the way those messages are removed
				freeform.setOption('removeMessages', function() {
					var errorBanners = this.form.querySelectorAll('.form__error-banner');
					errorBanners.forEach(function(errorBanner) {
						errorBanner.remove();
					});
					var successBanners = this.form.querySelectorAll('.form__success-banner');
					successBanners.forEach(function(successBanner) {
						successBanner.remove();
					});
					var errorListItems = this.form.querySelectorAll('.form__error-list');
					errorListItems.forEach(function(errorListItem) {
						errorListItem.remove();
					});
				});

				// Override the way form submit success message is displayed
				freeform.setOption('renderSuccess', function() {

					var bannerPopupform = this.form.closest(".banner-popup");
					if(typeof(bannerPopupform) !== "undefined" && bannerPopupform != null)
					{

						var _formType = this.form.querySelector("input[name^=fm-type]");
						if(typeof(_formType) !== "undefined" && _formType != "" && _formType != "undefined" && _formType != null && _formType.value == "page-last")
						{
							document.getElementById('popup-form-wrapper').setAttribute('style' , 'display:none');
							document.getElementById('popup-thank-you-wrapper').removeAttribute('style');
						}
						else
						{
							// document.getElementById('resubmission-form-input').value = response.submissionId;
							document.getElementById('content-form-part-1').setAttribute('style' , 'display:none');
							document.getElementById('content-form-part-2').removeAttribute('style');

							// document.getElementById('heading-form-part-1').setAttribute('style' , 'display:none');
							// document.getElementById('heading-form-part-2').removeAttribute('style');

							// var country = document.getElementById('country-popupNewsletter').value;
							// var zip = document.getElementById('zipCode-popupNewsletter').value;

							// Set values in hidden inputs of the second form
							// document.getElementById('page-last-firstName').value = fname;
							// document.getElementById('page-last-lastName').value = lname;
							// document.getElementById('page-last-email').value = email;							
							// var fname = this.form.querySelector('input[name^=firstName]').value;
							// var lname = this.form.querySelector('input[name^=lastName]').value;
							// var email = this.form.querySelector('input[name^=email]').value;
													
							// var _zip_code = this.form.querySelector('input[name^=zipCode]').value;
							// var _state = this.form.querySelector('select[name^=country]').value;
							// document.getElementById('page-last-email').setAttribute('value', email);
							// document.getElementById('page-last-firstName').setAttribute('value', fname);
							// document.getElementById('page-last-lastName').setAttribute('value', lname);
							// document.getElementById('page-last-zipCode').setAttribute('value', _zip_code);
							// document.getElementById('page-last-state').setAttribute('value', _state);

							var _btn = document.getElementById('content-form-part-2');
							_btn.querySelector(".btn").removeAttribute('disabled');

							setCookie('form-' + bannerPopupform.getAttribute('data-id'), '1', 365);
						}

						this.form.reset();
						return true;
					}

					// Retrieve/build the success message
					const successMessageCustom = this.form.querySelectorAll('.form__success');

					if ( successMessageCustom.length )
					{
						// Retrieve and show the success message
						var successMessage = successMessageCustom[0];
						successMessage.classList.add('show');
					}
					else
					{
						// Build the default success message
						var successMessage = document.createElement("div");
						successMessage.classList.add("row");
						let successMessageWrapper = document.createElement("div");
						successMessageWrapper.classList.add("form__html", "medium-12", "columns");
						let successMessageContent = document.createElement("div");
						successMessageContent.classList.add("form__success", "show");
						let successMessageParagraph = document.createElement("p");
						successMessageParagraph.appendChild(document.createTextNode("Thank you!"));
						successMessageContent.appendChild(successMessageParagraph);
						successMessageWrapper.appendChild(successMessageContent);
						successMessage.appendChild(successMessageWrapper);
						this.form.querySelectorAll("[type=submit]")[0].parentNode.parentNode.parentNode.appendChild(successMessage);
					}

					// Scroll to the success message
					// let successMessageOffset = offset(successMessage);
					let successMessageOffset = successMessage.getBoundingClientRect();
					if ( typeof(window.scroll) != "undefined" )
					{
						window.scroll({
							top: successMessageOffset.top + (window.scrollY - 100),
							left: 0,
							behavior: "smooth"
						});
					}

				});

				// Override the way form errors are displayed
				freeform.setOption('renderFormErrors', function(errors) {
					const errorBlock = document.createElement("div");
					errorBlock.classList.add("form__error-banner");

					const paragraph = document.createElement("p");
					paragraph.appendChild(document.createTextNode("Form contains errors!"));
					errorBlock.appendChild(paragraph);

					if (errors.length) {
						const errorsList = document.createElement("ul");
						for (let messageIndex = 0; messageIndex < errors.length; messageIndex++) {
							const message = errors[messageIndex];
							const listItem = document.createElement("li");

							listItem.appendChild(document.createTextNode(message));
							errorsList.appendChild(listItem);
						}

						errorBlock.appendChild(errorsList);
					}

					// this.form.insertBefore(errorBlock, this.form.childNodes[0]);
				});

				// Override the way field errors are displayed
				freeform.setOption('renderFieldErrors', function(errors)
				{
					for (const key in errors)
					{
						if (!errors.hasOwnProperty(key) || !key)
						{
							continue;
						}

						const messages = errors[key];
						const errorsList = document.createElement("ul");
						errorsList.classList.add("form__error-list");

						for (let messageIndex = 0; messageIndex < messages.length; messageIndex++)
						{
							const message = messages[messageIndex];
							const listItem = document.createElement("li");
							listItem.appendChild(document.createTextNode(message));
							errorsList.appendChild(listItem);
						}

						const inputList = this.form.querySelectorAll("*[name=" + key + "], *[name='" + key + "[]']");
						for (let inputIndex = 0; inputIndex < inputList.length; inputIndex++)
						{
							const input = inputList[inputIndex];
							input.classList.add("form__field-has-errors");
							var form__errors = [].slice.call(input.parentElement.parentElement.children).filter(el=>el.className==='form__error');
							form__errors[0].appendChild(errorsList);
						}
					}

					const fieldsWithErrors = this.form.querySelectorAll(".form__field-has-errors");
					if ( fieldsWithErrors.length )
					{
						// let firstFieldOffset = offset(fieldsWithErrors[0]);
						let firstFieldOffset = fieldsWithErrors[0].getBoundingClientRect();
						if ( typeof(window.scroll) != "undefined" )
						{
							window.scroll({
								top: firstFieldOffset.top + (window.scrollY - 100),
								left: 0,
								behavior: "smooth"
							});
						}
					}
				});

			});

		});
	}
}